import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';

import { ClassificacaoFaturamentoRoutingModule } from './classificacao-faturamento-routing.module';
import { ClassificacaoFaturamentoComponent } from './classificacao-faturamento.component';
import { ClassificacaoFaturamentoFormComponent} from './form';

@NgModule({
    imports: [
        SharedModule,
        ClassificacaoFaturamentoRoutingModule
    ],
    declarations: [
        ClassificacaoFaturamentoComponent,
        ClassificacaoFaturamentoFormComponent
    ]
})
export class ClassificacaoFaturamentoModule { }
